import {inject, observer} from "mobx-react";
import {toJS} from 'mobx';
import {Button} from 'antd';
import {
  WeaDialog,
  WeaSearchGroup,
  WeaFormItem,
  WeaRightMenu,
  WeaSelect,
  WeaTab,
  WeaLocaleProvider,
  WeaButtonIcon,
  WeaNewScroll,
  WeaDatePicker
} from 'ecCom';
import {WeaSwitch, WeaTableNew,WeaLogView} from 'comsMobx';
const {WeaTable} = WeaTableNew;
const WeaLogViewComp = WeaLogView.Component;
const getLabel = WeaLocaleProvider.getLabel;
import CoworkRichText from '../../../public/CoworkRichText';
import CoworkConstant from '../../../util/CoworkConstant';
import * as CoworkUtil from "../../../util/CoworkUtil";
import NewAuth from './NewAuth';

const coworkEngineNewPlateKey = 4;//调用后端新建版块的key

@inject("coworkStoreMap","coworkMainStore")
@observer
export default class NewCowork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLog: false,
			targetId: '',
    }
  }

  componentDidMount() {
    let initAddQuery = this.props.initAddQuery === undefined?{}:this.props.initAddQuery;
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    coworkNewStore.doInit(initAddQuery);
    if(!window.weaCoworkEngine){//新建协作要抛出去，所有要单独加载下
      // 异步加载别模块的静态资源
      setTimeout(() => {
        eventRegister.loadModule('b_cowork', ()=> {
          coworkNewStore.setLoaded(true)
        }, ()=> {
          // 加载文件失败 的业务处理， 网络超时，没文件之类
        },200)
      })
    }else{
      coworkNewStore.setLoaded(true)
    }
  }


  componentWillReceiveProps(nextProps) {
    if (this.props.random === undefined) {
    }else{
      let initAddQuery = this.props.initAddQuery === undefined?{}:this.props.initAddQuery;
      const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
      coworkNewStore.doInit(initAddQuery);
 
    }
  
  }

  getSearchs = () => {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {createForm, newCoworkStatus} = coworkNewStore;
    const {createCondition, createList, selectValue, associateList, dateValue} = toJS(newCoworkStatus);
    const {isFormInit} = createForm;
    let group = [];
    const formParams = createForm.getFormParams();
    const isAnonymous = associateList && associateList.length > 0 && associateList.filter(v => v.key == selectValue)[0] && associateList.filter(v => v.key == selectValue)[0].isAnonymous || '0';
    isFormInit && createCondition && createCondition.map(c => {
      let items = [];
      c.items.map(fields => {
        items.push({
          com: (
            <WeaFormItem
              label={`${fields.label}`}
              labelCol={{span: `${fields.labelcol}`}}
              wrapperCol={{span: `${fields.fieldcol}`}}
              error={createForm.getError(fields)}
              tipPosition="bottom"
              viewAttr={fields.viewAttr}
            >
              {fields.domkey[0] == 'typeId' ?
                <WeaSelect
                  hasAddBtn={fields.otherParams.hasAddBtn}
                  options={createList}
                  value={selectValue}
                  onChange={(v)=> {
                    coworkNewStore.setCreateState({selectValue : v});
                    coworkNewStore.getAccessoryPath(v)
                  }}
                  addOnClick={() => {
                    if(window.weaCoworkEngine){
                      const coworkEngineStoreMap = window.weaCoworkEngine.store && window.weaCoworkEngine.store.coworkEngineStoreMap;
                      const coworkPlateSetStore = coworkEngineStoreMap && coworkEngineStoreMap.getPlateSetStore(coworkEngineNewPlateKey);
                      coworkPlateSetStore && coworkPlateSetStore.setState({showNewPlate: true, createOrEdit: 0});
                    }
                  }}
                />
                :
                fields.domkey == 'endDate' ?
                  <WeaDatePicker
                    value={dateValue}
                    showTime
                    format="yyyy-MM-dd HH:mm"
                    placeholder={getLabel(83869,'请输入')+getLabel(743,'结束时间')}
                    style={{width: '100%'}}
                    onChange={v => {coworkNewStore.setCreateState({dateValue : v})}}
                  />
                  :
                <WeaSwitch fieldConfig={fields} form={createForm} formParams={formParams}/>
              }
            </WeaFormItem>),
          colSpan: 1,
          hide  : createForm.isHide(fields, (keys, allParams) => {
            let bool = false;
            fields.domkey[0] === 'isAnonymous' && isAnonymous == 0 && (bool=true)
            return bool;
          })
        })
      });
      group.push(<WeaSearchGroup col={1} center needTigger={true} title={getLabel(1361, '基本信息')} showGroup={true} items={items}/>)
    });
    return group;
  }

  getBaseInfo = () => {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    
    let {accessoryPath, itemsVO, createOrEdit, editCoworkInfo} = toJS(coworkNewStore.newCoworkStatus);
    if(createOrEdit == 1 && editCoworkInfo){//点击编辑按钮--编辑协作数据
      itemsVO=toJS(this.props.coworkMainStore.content.cowork.itemsVO);
    }
    
    //取新建协作默认带入的客户，项目等
    let {appData,appDataByType}=toJS(coworkNewStore.config);
    let relatedcusList = [...itemsVO.relatedcusList === undefined?[]:itemsVO.relatedcusList,...appDataByType.get("crm")=== undefined?[]:appDataByType.get("crm")];
    let relatedprjList = [...itemsVO.relatedprjList === undefined?[]:itemsVO.relatedprjList,...appDataByType.get("task")=== undefined?[]:appDataByType.get("task")];
    let relateddocList = [...itemsVO.relateddocList === undefined?[]:itemsVO.relateddocList,...appDataByType.get("doc")=== undefined?[]:appDataByType.get("doc")];
    let relatedwfList = [...itemsVO.relatedwfList === undefined?[]:itemsVO.relatedwfList,...appDataByType.get("workflow")=== undefined?[]:appDataByType.get("workflow")];
    let mutil_prjsList = [...itemsVO.mutil_prjsList === undefined?[]:itemsVO.mutil_prjsList,...appDataByType.get("project")=== undefined?[]:appDataByType.get("project")];

    return (
      <div style={{height: '100%', paddingBottom: createOrEdit == 1 ? 47 : 0}}>
        <WeaNewScroll height={'100%'}>
          {this.getSearchs()}
          <WeaSearchGroup
            title={getLabel(16284, '详细说明')}
            col={1}
            needTrigger={true}
            showGroup={true}
            items={[
              {
                com: <CoworkRichText
                  ref="rich"
                  richValue={itemsVO && itemsVO.remark}
                  relatedprjList4E9={itemsVO && relatedprjList}
                  relatedcusList4E9={itemsVO && relatedcusList}
                  relateddocList4E9={itemsVO && relateddocList}
                  relatedwfList4E9={itemsVO && relatedwfList}
                  relatemutilprjs4E9={itemsVO && mutil_prjsList}
                  relatedaccList4E9={itemsVO && itemsVO.relatedaccList}
                  accessoryPath={accessoryPath}
                />
              }
            ]}
          />
        </WeaNewScroll>
      </div>
    )
  }

  getBtns = () => {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {selectedKey, createOrEdit, saveLoading, saveSetLoading} = toJS(coworkNewStore.newCoworkStatus);
    let btns = [];
    if (selectedKey == 0) {
      btns.push(<Button type='primary' loading={saveLoading} onClick={() => this.onRightMenuClick('BTN_SAVE')}>{getLabel(86, '保存')}</Button>)
      createOrEdit == 0 && btns.push(
        <Button type='primary' loading={saveSetLoading} onClick={() => this.onRightMenuClick('BTN_SAVESET')}>{getLabel(32159, '保存并进入详细设置')}</Button>,)
    }
    return btns;
  }

  getRightMenu() {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {newCoworkStatus} = coworkNewStore;
    const {createOrEdit, selectedKey} = toJS(newCoworkStatus);
    let btnArr = [];
    if (selectedKey == 0) {
      btnArr.push(
        {
          key: 'BTN_SAVE',
          icon: <i className='icon-coms-Preservation'/>,
          content: `${getLabel(86, '保存')}`,
          onClick: () => this.onRightMenuClick('BTN_SAVE')
        }
      );

      createOrEdit == 0 &&
      btnArr.push({
        key: 'BTN_SAVESET',
        icon: <i className='icon-coms-Flow-setting'/>,
        content: `${getLabel(32159, '保存并进入详细设置')}`,
        onClick: () => this.onRightMenuClick('BTN_SAVESET'),
      })
    }else{
      btnArr.push({
        key: 'BTN_LOG',
        icon: <i className='icon-coms-Print-log'/>,
        content: `${getLabel(83, '日志')}`,
        onClick: () => this.onRightMenuClick('BTN_LOG'),
      })
    }
    return btnArr;
  }

  onRightMenuClick = (type) => {
    if (type == 'BTN_LOG') {//日志
      this.setState({showLog:true});
    }else{
      const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
      const {createForm, newCoworkStatus} = coworkNewStore;
      let {createOrEdit, editId, dateValue, selectValue} = toJS(newCoworkStatus);
      const formParams = createForm.getFormParams();
      const rich = this.refs.rich.wrappedInstance;
      const richParams = rich.getSubmitParams();
      const params = {
        ...formParams,
        isApply: Number(formParams.isApply) || 0, //isApply数据库存的是int
        endDate: dateValue, //结束时间
        typeId: selectValue, //版块
        operationType: createOrEdit == 0 ? 'add' : 'edit',
        id: createOrEdit == 0 ? '' : editId,
        relatedPrj: richParams.relatedprj,
        relatedCus: richParams.relatedcus,
        relatedWf: richParams.relatedwf,
        relatedDoc: richParams.relateddoc,
        projectIds: richParams.projectIDs,
        relatedAcc: richParams.relatedacc,
        remark: richParams.remark,
      }

      if (type == 'BTN_SAVE') {//保存
        CoworkUtil.onCheck(createForm, () => {
          coworkNewStore.saveorupdateCoworkItemVo(params, 'create',() => {
            if(this.props.saveCallback)this.props.saveCallback();//为外部调用 提供回调
          })
        })
      }
      if (type == 'BTN_SAVESET') {//保存并进入详细设置
        CoworkUtil.onCheck(createForm, () => {
          coworkNewStore.saveorupdateCoworkItemVo(params, 'saveSet')
        })
      }
    }
  }

  getTabBtns = () => {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {selectedKey, editId,selectValue} = coworkNewStore.newCoworkStatus;
    const selectedRowKeys = toJS(coworkNewStore.createTable.selectedRowKeys);
    let btns = selectedKey !=1 ? [] :
      [
        <WeaButtonIcon
          buttonType='add'
          type='primary'
          onClick={() => coworkNewStore.setCreateState({showAuth: true})}
        >
        </WeaButtonIcon>,
        <WeaButtonIcon
          buttonType='del'
          type='primary'
          disabled={selectedRowKeys.length == 0}
          onClick={() => {CoworkUtil.doConfirm(getLabel(82017,'确认删除？'),() => coworkNewStore.saveorupdateCoworkShare({id: editId,typeId: selectValue, shareId: selectedRowKeys.join(',')}))}}>
        </WeaButtonIcon>
      ]
    return btns;
  }

  onOperatesClick = (record, index, operate, flag) => {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {editId} = coworkNewStore.newCoworkStatus;
    if(operate.index == 0) {//删除
      CoworkUtil.doConfirm(getLabel(82017,'确认删除？'),() => coworkNewStore.saveorupdateCoworkShare({id: editId, shareId: record.id}));
    }
  }

  render() {
    const coworkNewStore = this.props.coworkStoreMap.getMapStore(this.props.storeMapKey);
    const {logStore,status} = coworkNewStore;
    const {logType,logSmallType,targetId,} = toJS(status);
    const {createOrEdit, selectedKey, showNewCowork} = coworkNewStore.newCoworkStatus;
    const title = createOrEdit == 0 ? getLabel(18034, '新建协作') : getLabel(83251, '编辑协作');
    const collectParams = {
      favname: title,
      favouritetype: 1,
      objid: 0,
      link: 'wui/index.html#/main/cowork/main',
      importantlevel: 1,
    }
    const topTab = [
      {
        title: getLabel(382637, '协作信息'),
        groupid: 'msg',
        viewcondition: 0
      },
      {
        title: getLabel(382638, '参与范围'),
        groupid: 'shareScope',
        viewcondition: 1
      }
    ];

    return (
      <div>
        <WeaDialog
          style={{width: 800, height: 565}}
          visible={showNewCowork}
          title={title}
          icon={CoworkConstant.iconClassName}
          iconBgcolor={CoworkConstant.iconBgColor}
          className='wea-cowork-new'
          onCancel={() => {
            coworkNewStore.setCreateState({showNewCowork: false});
            coworkNewStore.doCreateFormInit();
            this.props.onCancel && this.props.onCancel();
          }}
          hasScroll
          buttons={this.getBtns()}
          moreBtn={{
            datas: this.getRightMenu(),
            collectParams: collectParams
          }}
        >
          <WeaRightMenu
            datas={this.getRightMenu()}
            collectParams={collectParams}
          >
            {createOrEdit == 0 ?
              this.getBaseInfo()
              :
              <div style={{height: '100%'}}>
                <WeaTab
                  datas={topTab}
                  keyParam="viewcondition"
                  countParam="groupid"
                  selectedKey={selectedKey}
                  buttons={this.getTabBtns()}
                  onChange={v => coworkNewStore.setCreateState({selectedKey: v})}
                />
                {
                  selectedKey == 0 ?
                    this.getBaseInfo() :
                    <WeaTable
                      comsWeaTableStore={coworkNewStore.createTable}
                      hasOrder={true}
                      needScroll={true}
                      onOperatesClick={this.onOperatesClick.bind(this)}
                    />
                }
              </div>
            }
          </WeaRightMenu>

          <NewAuth storeMapKey={this.props.storeMapKey}/>
          {coworkNewStore.loaded && window.weaCoworkEngine && window.weaCoworkEngine.com && window.weaCoworkEngine.com.CreatePlat &&
          (<window.weaCoworkEngine.com.CreatePlat
            storeMapKey={coworkEngineNewPlateKey}
            saveCallBack={()=>{
              coworkNewStore.getNewMyCoworkTypeList();
            }}
          />)}
        </WeaDialog>
        <WeaLogViewComp
						visible={this.state.showLog}
						onCancel={() => this.setState({showLog: false})}
						logStore={logStore}
						logType={logType}
						logSmallType={logSmallType}
						targetId={this.state.targetId}
					/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/dialog/NewCowork.js